const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "name_contains",
      label: "Agent Name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "staff_name_contains",
      label: "Staff Name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DepartmentMultiFilter"),
    props: {
      filterName: "departments_eq",
      label: "Department",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "email_contains",
      label: "Email",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "company_code_contains",
      label: "Code",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/AgentTypeMultiFilter"),
    props: {
      filterName: "agent_type_eq",
      label: "Agent Type",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "not_in_use_eq",
      label: "Not in use",
      filterValue: { not_in_use_eq: false },
    },
    defaultValue: { not_in_use_eq: false },
    defaultLabel: false,
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/agents/agents-filters.js